import { Col, Form, Input, Row, Select, Radio } from 'antd';
import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import formUtil from '../../../../../../../../../utils/form';
import { EnrollmentFormContext } from '../../../../../../../../../providers/EnrollmentFormContextProvider';
import useParams from '../../../../../../../../params/useParams';
import paramType from '../../../../../../../../params/paramEndpoints';
import InputRut from '../../../../../../../../../components/form/inputs/InputRut';
import IdentificationType from '../../../../../../../../../enums/identificationType';
import StrDatePicker from '../../../../../../../../../components/common/inputs/StrDatePicker';

const messageRequiredData = 'Dato requerido';

const CivilPartner = ({ gutter, title, index, setPartnerCivilAdress }) => {
  const [selectedRut, setSelectedRut] = useState(false);
  const [form] = Form.useForm();
  const [civilStatuses, areCivilStatusesLoading] = useParams(paramType.CIVIL_STATUSES);
  const [countries, areCountriesLoading] = useParams(paramType.COUNTRIES);
  const [patrimonialRegimes, arePatrimonialRegimesLoading] = useParams(
    paramType.PATRIMONIAL_REGIMES
  );
  const [sexes, areSexesLoading] = useParams(paramType.SEXES);

  const { enrollmentForm } = useContext(EnrollmentFormContext);

  const [showsPartnerForm, setShowsPartnerForm] = useState(
    () => enrollmentForm.getFieldValue(['legalRepresentatives', index, 'civilStatus']) === 'CASADO'
  );

  const toggleRutCheck = () => {
    setSelectedRut(true);
  };

  const togglePassportCheck = () => {
    setSelectedRut(false);
  };

  const handleCivilStatusChange = (value) => {
    setShowsPartnerForm(value === 'CASADO');
    setPartnerCivilAdress(value === 'CASADO');
  };

  return (
    <>
      <Row gutter={gutter}>
        <Col lg={12} xs={24}>
          <Form.Item
            name={['legalRepresentatives', index, 'civilStatus']}
            label="Estado civil"
            shouldUpdate
            rules={[{ required: true, message: messageRequiredData }]}
          >
            <Select
              placeholder="Seleccionar"
              onChange={handleCivilStatusChange}
              loading={areCivilStatusesLoading}
            >
              {civilStatuses.map(({ id, name }) => (
                <Select.Option key={id} value={id}>
                  {name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        {showsPartnerForm && (
          <>
            <Col lg={12} xs={24}>
              <Form.Item
                name={['legalRepresentatives', index, 'partner', 'patrimonialRegime']}
                label="Régimen patrimonial"
                rules={[{ required: true, message: messageRequiredData }]}
              >
                <Select placeholder="Seleccionar" loading={arePatrimonialRegimesLoading}>
                  {patrimonialRegimes.map(({ name, id }) => (
                    <Select.Option key={id} value={id}>
                      {name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={24}>
              <Row>
                <Col span={24}>
                  <p className="personalDocumentsForm__title">{title}</p>
                </Col>
              </Row>
              <Row gutter={gutter}>
                <Col span={24}>
                  <Form.Item
                    name={['legalRepresentatives', index, 'partner', 'name']}
                    label="Nombre"
                    rules={[{ required: true, message: messageRequiredData }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} lg={12}>
                  <Form.Item
                    name={['legalRepresentatives', index, 'partner', 'firstSurname']}
                    label="Apellido Paterno"
                    rules={[{ required: true, message: messageRequiredData }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} lg={12}>
                  <Form.Item
                    name={['legalRepresentatives', index, 'partner', 'secondSurname']}
                    label="Apellido Materno"
                    rules={[{ required: false, message: messageRequiredData }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[gutter]}>
                <Col span={24}>
                  <Form.Item
                    name={['legalRepresentatives', index, 'partner', 'identificationType']}
                  >
                    <Radio.Group defaultValue={1}>
                      <Radio value={IdentificationType.RUT} onChange={toggleRutCheck}>
                        Rut
                      </Radio>
                      <Radio value={IdentificationType.PASAPORTE} onChange={togglePassportCheck}>
                        Pasaporte
                      </Radio>
                      <Radio value={IdentificationType.OTRO} onChange={togglePassportCheck}>
                        Otro
                      </Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[gutter]}>
                <Col lg={{ span: 12 }} xs={24}>
                  <Form.Item
                    label="N° de Identificación"
                    name={['legalRepresentatives', index, 'partner', 'identification']}
                    rules={[
                      {
                        required: true,
                        message: 'N° de Identificación es requerido',
                      },
                    ]}
                  >
                    {selectedRut ? <InputRut /> : <Input />}
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col lg={12} xs={24}>
                  <Form.Item
                    name={['legalRepresentatives', index, 'partner', 'nationality']}
                    label="Nacionalidad"
                    rules={[{ required: true, message: messageRequiredData }]}
                  >
                    <Select placeholder="Seleccionar" loading={areCountriesLoading}>
                      {countries.map(({ id, name }) => (
                        <Select.Option key={id} value={id}>
                          {name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={gutter}>
                <Col lg={12} xs={24}>
                  <Form.Item
                    name={['legalRepresentatives', index, 'partner', 'dateOfBirth']}
                    label="Fecha de nacimiento"
                    rules={[{ required: true, message: messageRequiredData }]}
                  >
                    <StrDatePicker
                      defaultPickerValue={formUtil.date.defaultValue.yearsAgo(30)}
                      showToday={false}
                      disabledDate={formUtil.date.dateDisablers.disabledDate()}
                      format={formUtil.date.format.day}
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>
                <Col lg={12} xs={24}>
                  <Form.Item
                    name={['legalRepresentatives', index, 'partner', 'sex']}
                    label="Sexo"
                    rules={[{ required: true, message: messageRequiredData }]}
                  >
                    <Select placeholder="Seleccione una opción" loading={areSexesLoading}>
                      {sexes.map((sex) => (
                        <Select.Option key={sex.id} value={sex.id}>
                          {sex.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={gutter}>
                <Col lg={12} xs={24}>
                  <Form.Item
                    name={['legalRepresentatives', index, 'partner', 'email']}
                    label="E-mail"
                    rules={[{ required: true, type: 'email', message: messageRequiredData }]}
                  >
                    <Input
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/\s/g, ''); // Eliminar espacios en tiempo real
                      }}
                      onChange={(e) => {
                        const trimmedValue = e.target.value.trim();
                        const legalRepresentatives =
                          form.getFieldValue('legalRepresentatives') || [];
                        if (legalRepresentatives[index] && legalRepresentatives[index].partner) {
                          legalRepresentatives[index].partner.email = trimmedValue;
                          form.setFieldsValue({ legalRepresentatives });
                        }
                      }}
                    />
                  </Form.Item>
                  </Col>
                  <Col lg={12} xs={24}>
                  <Form.Item
                    label="Reescriba su e-mail"
                    rules={[
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (
                            !value ||
                            getFieldValue('legalRepresentatives')[index]?.partner?.email === value
                          ) {
                            return Promise.resolve();
                          }
                          return Promise.reject(new Error('Email no es igual al primero digitado'));
                        },
                      }),
                    ]}
                    name={['legalRepresentatives', index, 'partner', 'emailValidation']}
                  >
                    <Input
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/\s/g, ''); // Eliminar espacios en tiempo real
                      }}
                      onChange={(e) => {
                        const trimmedValue = e.target.value.trim();
                        const legalRepresentatives =
                          form.getFieldValue('legalRepresentatives') || [];
                        if (legalRepresentatives[index] && legalRepresentatives[index].partner) {
                          legalRepresentatives[index].partner.emailValidation = trimmedValue;
                          form.setFieldsValue({ legalRepresentatives });
                        }
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={gutter}>
                <Col lg={12} xs={24}>
                  <Form.Item
                    name={['legalRepresentatives', index, 'partner', 'phone']}
                    label="Teléfono Móvil"
                    rules={[{ required: true, message: messageRequiredData, len: 9 }]}
                  >
                    <Input placeholder="987654321" />
                  </Form.Item>
                </Col>
                <Col lg={12} xs={24}>
                  <Form.Item
                    name={['legalRepresentatives', index, 'partner', 'phoneAlt']}
                    label="Teléfono Fijo (Opcional)"
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          </>
        )}
      </Row>
    </>
  );
};

CivilPartner.propTypes = {
  gutter: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  index: PropTypes.string.isRequired,
  setPartnerCivilAdress: PropTypes.func.isRequired,
};

export default CivilPartner;
